/**
 * Carousel - styles
 */

import styled from 'styled-components';

export const CarouselContainer = styled.div`
	width: 100%;
`;
